import { Model } from 'modules/core/lib/mobx-rest'
import type { Analytic } from 'modules/core/store/models/Analytic'

export interface Attributes {
  id: number
  average_age: Analytic<number>
  tenure: Analytic<string>
  diversity: Analytic<number>
}

class TeamAnalytics extends Model<Attributes> {
  static urlRoot() {
    return '/analytics/teams'
  }
}

export default TeamAnalytics
